import './BackButton.css';

function BackButton(props:{
    title: string,
    onClick: () => void,
}){
    return(
        <button 
        className='back-button' 
        onClick={
            props.onClick
            
        }>
            {props.title}
        </button>
    )
}

export default BackButton;